import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import ShipmentDistributor from './modals/ShipmentDistributor';
import Movements from './modals/Movements';
import Pagination from 'components/Pagination';
import FilterSearch from 'components/FilterSearch';
import ShipOrder from 'pages/warehouse_finished/modals/ShipOrder';

import { GET, httpOk } from 'helpers/api';
import { checkPermission, DOWNLOAD_FILE, formatDate, formatMoney } from 'helpers/helpers';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import CustomSelect from 'components/CustomSelect';

function WarehouseFg() {
    const { t } = useTranslation()

    const views = [
        {
            id: 'products',
            name: t('products')
        },
        {
            id: 'boxes',
            name: t('boxes')
        },
    ]

    const [shipmentDistributorModal, setShipmentDistributorModal] = useState(false)
    const [movementsModal, setMovementsModal] = useState({ show: false, id: '' })
    const [shipOrderModal, setShipOrderModal] = useState({ show: false, id: '' })

    const initFilterData = {
        page: 1,
        page_size: 20,
        search: '',
        status: '',
        view: 'products',
    }

    const [filterData, setFilterData] = useState(initFilterData)

    const [data, setData] = useState({})

    async function exportFile() {
        await DOWNLOAD_FILE('/inventory/fg-warehouse/items/export/', filterData, t('finished_goods'))
    }

    const handlePaginate = (args) => {
        setFilterData(prev => ({
            ...prev,
            page: args.page + 1,
            page_size: args.page_size
        }));
    };

    const getData = useCallback(async () => {
        const [response, responseStats] = await Promise.all([
            GET('/inventory/fg-warehouse/dashboard/', filterData),
            GET('/inventory/fg-warehouse/items/', filterData),
        ]);

        if (httpOk(response)) {
            setData({ ...response.data, ...responseStats.data });
        }
    }, [filterData]);

    useEffect(() => {
        getData();
    }, [getData]);

    return (
        <>
            <div className="d-between">
                <div>
                    <div className="main-content-title">
                        {t('finished_goods')}
                    </div>

                    <div className="main-content-subtitle">
                        {t('stock_shipment_management_desc')}
                    </div>
                </div>

                <div className="d-flex gap-8">
                    {/* <button className="white gap-16" onClick={() => setAcceptanceProductionModal(true)}>
                        <PlusIcon />
                        {t('receipt_from_production')}
                    </button> */}

                    {/* {checkPermission("inventory.finished.ship") &&
                        <button className="dark gap-16" onClick={() => setShipmentDistributorModal(true)}>
                            <TruckIcon />
                            {t('shipment')}
                        </button>
                    } */}
                </div>
            </div>

            <div className="grid4 gap-16">
                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('total_balance')}
                            </div>
                            <div className="value primary">
                                {formatMoney(data?.summary?.total_quantity)} {data?.summary?.unit_short_name}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div>
                        <div className="title">
                            {t('reserved')}
                        </div>
                        <div className="value text-warning">
                            {formatMoney(data?.summary?.reserved_total)} {data?.summary?.unit_short_name}
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('available')}
                            </div>
                            <div className="value text-success">
                                {formatMoney(data?.summary?.available_total)} {data?.summary?.unit_short_name}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('orders_for_shipment')}
                            </div>
                            <div className="value">
                                {formatMoney(data?.summary?.pending_orders)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="d-flex gap-16 w-100">
                    <FilterSearch
                        value={filterData.search}
                        onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
                        placeholder={t('search_by_sku_or_name')}
                    />

                    <CustomSelect
                        options={views}
                        value={views.find(option => option.id === filterData?.view) || ''}
                        onChange={(option) => setFilterData({ ...filterData, view: option?.id })}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        isClearable={false}
                    // placeholder={t('select')}
                    />


                    <button className="white third" onClick={() => exportFile()}>
                        <DownloadIcon />
                        {t('export')}
                    </button>
                </div>
            </div>

            <div className="card">
                <div className="d-between mb-30">
                    <div className="fz16 text-third">
                        {t('finished_goods')}
                    </div>
                </div>

                {filterData.view === 'products' ?
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ width: '10%' }}>{t('sku')}</th>
                                <th style={{ width: '20%' }}>{t('name')}</th>
                                <th style={{ width: '10%' }}>{t('balance')}</th>
                                <th style={{ width: '10%' }}>{t('reserved')}</th>
                                <th style={{ width: '10%' }}>{t('available')}</th>
                                <th style={{ width: '10%' }}>{t('batch')}</th>
                                <th style={{ width: '10%' }}>{t('unit_short')}</th>
                                <th style={{ width: '10%' }}>{t('actions')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.results?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.product_code}</td>
                                    <td>{item.product_name}</td>
                                    <td>{formatMoney(item.quantity)} {item.unit_short_name}</td>
                                    <td>{formatMoney(item.reserved_quantity)} {item.unit_short_name}</td>
                                    <td>{formatMoney(item.available_quantity)} {item.unit_short_name}</td>
                                    <td>{formatDate(item.last_updated)}</td>
                                    <td>{item.unit_short_name}</td>
                                    <td>
                                        <div className="d-flex align-items-center gap-8">
                                            <button className="transparent small" onClick={() => setMovementsModal({ show: true, id: item.product_id })}>
                                                {t('movements')}
                                            </button>
                                            {(checkPermission("inventory.finished.ship") && item.reserved_quantity > 0) &&
                                                <button className="white small" onClick={() => setShipOrderModal({ show: true, id: item.product_id })}>
                                                    {t('ship')}
                                                </button>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    :
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ width: '10%' }}>{t('sku')}</th>
                                <th style={{ width: '20%' }}>{t('name')}</th>
                                <th style={{ width: '10%' }}>{t('balance')}</th>
                                <th style={{ width: '10%' }}>{t('reserved')}</th>
                                <th style={{ width: '10%' }}>{t('available')}</th>
                                <th style={{ width: '10%' }}>{t('batch')}</th>
                                <th style={{ width: '10%' }}>{t('unit_short')}</th>
                                <th style={{ width: '10%' }}>{t('actions')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.results?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.product_code}</td>
                                    <td>{item.box_name}</td>
                                    <td>{formatMoney(item.quantity)} {item.unit_short_name}</td>
                                    <td>{formatMoney(item.reserved_quantity)} {item.unit_short_name}</td>
                                    <td>{formatMoney(item.available_quantity)} {item.unit_short_name}</td>
                                    <td>{formatDate(item.last_updated)}</td>
                                    <td>{item.unit_short_name}</td>
                                    <td>
                                        <div className="d-flex align-items-center gap-8">
                                            <button className="transparent small" onClick={() => setMovementsModal({ show: true, id: item.product_id })}>
                                                {t('movements')}
                                            </button>
                                            {(checkPermission("inventory.finished.ship") && item.reserved_quantity > 0) &&
                                                <button className="white small" onClick={() => setShipOrderModal({ show: true, id: item.product_id })}>
                                                    {t('ship')}
                                                </button>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }


                <Pagination
                    paginate={handlePaginate}
                    pagination={{
                        total: data?.count || 0
                    }}
                />

                {/* <AcceptanceProduction modal={acceptanceProductionModal} setModal={setAcceptanceProductionModal} /> */}
                <ShipmentDistributor modal={shipmentDistributorModal} setModal={setShipmentDistributorModal} />
                <Movements modal={movementsModal.show} setModal={() => setMovementsModal({ show: false })} id={movementsModal.id} />
                {checkPermission("inventory.finished.ship") &&
                    <ShipOrder modal={shipOrderModal.show} setModal={() => setShipOrderModal({ show: false })} id={shipOrderModal.id} getData={getData} />
                }
            </div>
        </>
    )
}

export default WarehouseFg